<script setup lang="ts">
import useCurrentSearch from '@/components/goods-view/searchDataStore';
import StfDivider from '@/ui/divider/StfDivider.vue';
import GoodClassDisplay from '@/components/goods-view/components/good-class-display.vue';
import {computed, ref} from 'vue';
import StfIcon from '@/ui/icon/StfIcon.vue';
import { useProductStore } from '@/store/good';
import { storeToRefs } from 'pinia';
import { buildProductSearchResultWithProductCart } from '../productSearchUtils';

const {currentSearch} = useCurrentSearch();
const productStore = useProductStore();
const {classes, goods} = storeToRefs(productStore);
const numberOfClassDisplayed = ref(3);
const MAX_CLASS_DISPLAYED = 6;

const showMoreClass = () => {
    const classDisplayed = numberOfClassDisplayed.value + 3;
    //max 6
    if (classDisplayed > MAX_CLASS_DISPLAYED) {
        numberOfClassDisplayed.value = MAX_CLASS_DISPLAYED;
        return;
    }

    numberOfClassDisplayed.value = classDisplayed;
}

const combinedClasses = computed(() => {
    return buildProductSearchResultWithProductCart(currentSearch.value.classes, classes.value, goods.value);
});

const classToDisplay = computed(() => {
    if (combinedClasses.value.length <= numberOfClassDisplayed.value) {
        return combinedClasses.value;
    }

    return combinedClasses.value.slice(0, numberOfClassDisplayed.value);
})

const allClasses = computed(() => {
    return combinedClasses.value.length <= numberOfClassDisplayed.value || numberOfClassDisplayed.value >= MAX_CLASS_DISPLAYED;
})
</script>

<template>
    <div>
        <template v-for="(goodClass, index) in classToDisplay" :key="goodClass.id">
            <GoodClassDisplay :good-class="goodClass" :index="index"/>
            <StfDivider v-if="index < classToDisplay.length - 1"/>
        </template>
        <div v-if="!allClasses">
            <StfDivider/>
            <StfRow @click="showMoreClass" hcenter vcenter>
                <StfCol narrow>
                    <StfBody class="bulma-is-display-inline-block"><u>More classes</u></StfBody>
                </StfCol>
                <StfCol narrow>
                    <StfIcon icon="chevronDown"/>
                </StfCol>
            </StfRow>
        </div>
    </div>
</template>
